import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { ColumnType } from 'antd/es/table';

import { DragButton } from '@/shared/components';

import type { ISectionItemData } from './types';

export const getColumnsData = ({
  openEditProgramSectionModal,
  openDeleteProgramSectionModal,
  setItemToOperate,
}: {
  openEditProgramSectionModal: VoidFunction;
  openDeleteProgramSectionModal: VoidFunction;
  setItemToOperate: (data: ISectionItemData | null) => void;
}) =>
  [
    {
      title: 'Наименование раздела',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: 'Описание раздела',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 216,
      render: (_, { id, name, position, description }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DragButton rowKey={position} />
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, name, position, description });
              openEditProgramSectionModal();
            }}
          >
            <EditOutlined style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, name, position, description });
              openDeleteProgramSectionModal();
            }}
          >
            <DeleteOutlined style={{ fontSize: '20px' }} />
          </Button>
        </div>
      ),
      fixed: 'right',
    },
  ] as ColumnType<ISectionItemData>[];
